import { Link } from "react-router-dom";
import { Phone, Calendar, FileText, Clock, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";

const FinalCTASection = () => {
  return (
    <section className="section-padding bg-secondary relative overflow-hidden">
      <div className="container-custom relative z-10">
        {/* Main CTA */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold font-heading text-white mb-4">
            READY TO TRANSFORM YOUR PROPERTY?
          </h2>
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
            Get your free quote today – no obligation
          </p>

          <div className="flex flex-wrap justify-center gap-4 mb-8">
            <a href="tel:+12762123137">
              <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-bold text-lg px-8 py-6 shadow-lg">
                <Phone className="w-5 h-5 mr-2" />
                Call (276) 212-3137
              </Button>
            </a>
            <Link to="/contact">
              <Button size="lg" className="bg-white text-secondary hover:bg-gray-100 font-bold text-lg px-8 py-6 shadow-lg">
                <Calendar className="w-5 h-5 mr-2" />
                Book Online
              </Button>
            </Link>
            <Link to="/contact">
              <Button size="lg" variant="outline" className="border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground font-bold text-lg px-8 py-6">
                <FileText className="w-5 h-5 mr-2" />
                Get Free Estimate
              </Button>
            </Link>
          </div>

          <p className="text-primary font-semibold text-lg">
            🎖️ First Responders & Military: Ask about your 10% discount!
          </p>
        </div>

        {/* Business Hours and Map Section */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          <div className="bg-charcoal-dark/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-primary/20 p-2 rounded-lg"><Clock className="w-6 h-6 text-primary" /></div>
              <h3 className="text-xl font-bold text-white">Business Hours</h3>
            </div>
            <div className="space-y-3 text-gray-300">
              <div className="flex justify-between py-2 border-b border-gray-700"><span>Monday - Friday</span><span className="font-semibold text-white">7:00 AM - 7:00 PM</span></div>
              <div className="flex justify-between py-2 border-b border-gray-700"><span>Saturday</span><span className="font-semibold text-white">8:00 AM - 5:00 PM</span></div>
              <div className="flex justify-between py-2"><span>Sunday</span><span className="font-semibold text-white">By Appointment</span></div>
            </div>
            <p className="text-gray-300 text-sm mt-4">* Emergency services available for commercial clients</p>
          </div>

          <div className="bg-charcoal-dark/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-primary/20 p-2 rounded-lg"><MapPin className="w-6 h-6 text-primary" /></div>
              <h3 className="text-xl font-bold text-white">Service Area</h3>
            </div>
            <div className="rounded-lg overflow-hidden h-48">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d394827.6273833366!2d-78.33626266828882!3d39.36550140148289!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa21e982c99baec1f%3A0x9e9f5baba0415a1!2sStream%20Masters%20Power%20Washing%20LLC!5e0!3m2!1sen!2sus!4v1772821990244!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Service Area Map"
              ></iframe>
            </div>
            <p className="text-gray-300 text-sm mt-3">Serving MD, WV & VA - Martinsburg, Hagerstown, Winchester & surrounding areas</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;